import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  style: {"margin-bottom":"-6px"}
}
const _hoisted_4 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "horizontal-scroll" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_home_action_header = _resolveComponent("home-action-header")!
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_event_card = _resolveComponent("event-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return ($setup.loadingData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        ($setup.userRelatedJobEX.homePageProfessionIds || $setup.userRelatedJobEX['Embedded Video Link'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($setup.loadingPortalData)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      ($setup.userRelatedJobEX['Embedded Video Link'])
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              ($setup.userRelatedJobEX['Embedded Video Link'].startsWith('http'))
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 0,
                                    class: "responsive-embed",
                                    width: "100%",
                                    height: "350px",
                                    frameborder: "0",
                                    allowfullscreen: "",
                                    src: $setup.userRelatedJobEX['Embedded Video Link']
                                  }, null, 8, _hoisted_5))
                                : (_openBlock(), _createBlock(_component_ion_card, {
                                    key: 1,
                                    class: "ion-text-center",
                                    color: "primary",
                                    style: {"border-radius":"16px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            icon: $setup.play,
                                            style: {"font-size":"60px","margin":"0 auto"}
                                          }, null, 8, ["icon"]),
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.userRelatedJobEX['Embedded Video Link']), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_card_subtitle, null, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                              _createTextVNode("Video coming soon")
                                            ])),
                                            _: 1,
                                            __: [7]
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ($setup.userRelatedJobEX.homePageProfessionIds)
                        ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userRelatedJobEX.homePageProfessionIds, (id) => {
                                  return (_openBlock(), _createBlock(_component_ion_chip, {
                                    key: id,
                                    onClick: ($event: any) => ($setup.openProfessionModal(id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.userRelatedJobEX.homePageProfessionPrefix) + _toDisplayString($setup.getProfessionNameById(id)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true),
        ($setup.userRelatedJobEX['Show Yr 1 Academic advising?'] == 'Y')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_home_action_header, { title: "Yr 1" }),
              _createVNode(_component_ion_card, { style: {"margin-top":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_home_action_item, {
                        title: "Talk (coming soon)",
                        extraNote1: "Apply",
                        extraNote2: "Roll call...",
                        isLesson: true,
                        isDisabled: true
                      }),
                      _createVNode(_component_home_action_item, {
                        title: "Explore career prospects",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openYr1ExploreProfessionModal()))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_home_action_header, {
          title: ($setup.user.yearOfStudy || '').startsWith('Year') ? 'Yr 1 - 4' : 'Resources'
        }, null, 8, ["title"]),
        _createVNode(_component_ion_card, { style: {"margin-top":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion_group, { value: "jobEX workshop" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, {
                      style: {"--min-height":"24px"},
                      value: "jobEX workshop"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          class: "ion-no-padding",
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: null
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("span", null, [
                                  _createElementVNode("b", null, "Lecture - Educated job seeking")
                                ], -1)
                              ])),
                              _: 1,
                              __: [8]
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_list, {
                          class: "ion-no-padding",
                          slot: "content"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredJobEXIntakeSessions('workshop2'), (ev) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                key: ev.id,
                                ev: ev,
                                user: $setup.user,
                                showStudentFormsOnly: true,
                                useAccordionView: true
                              }, null, 8, ["ev", "user"])), [
                                [_vShow, ev.formattedDateTime && $setup.isShowEvent(ev)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_home_action_item, {
                  title: "400+ professions | 300+ employer segments",
                  isDone: $setup.jobEXIsSelectedProfessions(),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.jobEXOpenProfessionSelectModal())),
                  noIndent: true
                }, null, 8, ["isDone"]),
                _createVNode(_component_home_action_item, {
                  title: "AI-powered AchieveCV & AchieveCL",
                  isDone: $setup.user.isCvReady,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openCVModal())),
                  noIndent: true
                }, null, 8, ["isDone"]),
                _createVNode(_component_home_action_item, {
                  title: "Online consultation",
                  isLesson: true,
                  isDone: !!$setup.user.consultation,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openBookingModal('bi82ce0b45')))
                }, null, 8, ["isDone"]),
                ($setup.userRelatedJobEX['Show guest lecture?'] == 'Y')
                  ? (_openBlock(), _createBlock(_component_home_action_item, {
                      key: 0,
                      title: "Guest lecture",
                      extraNote1: "Apply",
                      extraNote2: "Roll call...",
                      isLesson: true,
                      isDone: !!$setup.user.l3,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openJobEXEventsModal('cc31fb5c1', $setup.user.l3)))
                    }, null, 8, ["isDone"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_home_action_header, { title: "Job opportunities" }),
        _createVNode(_component_ion_card, { style: {"margin-top":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_home_action_item, {
                  title: "Bluebird",
                  noIndent: true,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openServiceModal('bluebird')))
                }),
                _createVNode(_component_home_action_item, {
                  title: "Term-time internship",
                  noIndent: true
                }),
                _createVNode(_component_home_action_item, {
                  title: "Summer internship",
                  noIndent: true
                }),
                _createVNode(_component_home_action_item, {
                  title: "Graduation jobs",
                  noIndent: true
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_ion_card, { class: "class-bar" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          color: "primary",
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { style: {"margin":"4px 8px"} }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("h2", null, "Share this tool with my classmates", -1)
                              ])),
                              _: 1,
                              __: [9]
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_list, {
                          class: "ion-text-center",
                          slot: "content"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createElementVNode("img", {
                                style: {"width":"300px"},
                                src: $setup.getQRCodeUrl(`https://ab.fdmt.hk/u/${$setup.user.programId}`)
                              }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("p", null, "ab.fdmt.hk/u/" + _toDisplayString($setup.user.programId), 1),
                            _createVNode(_component_ion_button, {
                              color: "success",
                              size: "small",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.copyText(`https://ab.fdmt.hk/u/${$setup.user.programId}`)))
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode(" Copy ")
                              ])),
                              _: 1,
                              __: [10]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, $setup.user.isAdmin || $setup.user.uniEmail]
        ])
      ]))
}